import { forwardRef } from "react";

import { useTheme } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import {
  BaseFormPaymentMethod,
  BaseFormPaymentMethodProps,
} from "@/forms-design-system/FormPaymentMethod/BaseFormPaymentMethod";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";
import { StripeBank } from "@/icons/external";

type PadFormPaymentMethodProps = Omit<BaseFormPaymentMethodProps, "icon" | "label">;

export const PadFormPaymentMethod = forwardRef<HTMLDivElement, PadFormPaymentMethodProps>(({ ...rest }, ref) => {
  const theme = useTheme();
  const { t } = useTranslate();

  if (!theme.palette.forms || !theme.palette.formsComponents?.paymentMethod) {
    return <InvalidThemeErrorMessage />;
  }

  return <BaseFormPaymentMethod ref={ref} icon={<StripeBank />} label={t("common", "paymentMethod.pad")} {...rest} />;
});

PadFormPaymentMethod.displayName = "PadFormPaymentMethod";
